import "./ChuChayMobile.scss";

function ChuChayMobile() {
  return (
    <div className="app_marquee app_broadcast has_recommend">
      <div className="app_marquee_context">
        <div className="marquee-text-wrap">
          <div className="marquee-text-content">

            {/* BLOCK 1 */}
            <div className="marquee-text-text">
              <div className="app-marquee__marquees">

                <p className="app-marquee__item">
                  ⭐️ เดิมพันเต็มที่ – รับเงินคืนทันทีสูงสุด 2.5% ⭐️

                  สนุกกับการเดิมพัน พร้อมรับสิทธิ์เงินคืนตามเงื่อนไขของโปรโมชั่น
                  โดยไม่ต้องรอถึงวันถัดไป!

                  ✤ วิธีรับเงินคืน:
                  ไปที่เมนู “ของฉัน” ➤ เลือก “รับเงินคืนทันที”
                  ➤ กด “คำนวณเงินคืน” ➤ รับเงินคืนตามยอดที่ระบบแสดง
                </p>

                <p className="app-marquee__item">
                  🇹🇭💦 ฉลองเทศกาลสงกรานต์กับ QK88BET 💦🇹🇭

                  🎉 สุขสันต์วันสงกรานต์ – เทศกาลปีใหม่ไทย
                  พบกับกิจกรรมพิเศษ โบนัส และสิทธิประโยชน์มากมายสำหรับสมาชิก

                  💦 ร่วมสนุกตลอดช่วงเทศกาลสงกรานต์
                  พร้อมติดตามกิจกรรมและโปรโมชั่นพิเศษจาก QK88BET

                  🎁 โปรโมชั่นและกิจกรรมอาจแตกต่างกันไปตามช่วงเวลา
                  กรุณาตรวจสอบรายละเอียดและเงื่อนไขจากหน้าโปรโมชั่นก่อนเข้าร่วม

                  🍀 ขอให้สมาชิกทุกท่านมีความสุข สนุก และโชคดีตลอดเทศกาลสงกรานต์!
                </p>

                <p className="app-marquee__item">
                  🎆🎁 ฉลองเทศกาลปีใหม่กับ QK88BET 🎁🎆

                  เริ่มต้นปีใหม่ด้วยความสนุก
                  พร้อมกิจกรรมและโปรโมชั่นพิเศษสำหรับสมาชิก

                  🎊 พบกับโบนัส กิจกรรม และสิทธิประโยชน์ต่าง ๆ
                  ที่จัดขึ้นในช่วงเทศกาลปีใหม่

                  📌 ติดตามรายละเอียดล่าสุดได้จากหน้าโปรโมชั่น
                  หรือสอบถามฝ่ายบริการลูกค้าออนไลน์

                  🎉 QK88BET ขอให้สมาชิกทุกท่านมีความสุขและโชคดีตลอดปี!
                </p>

                <p className="app-marquee__item">
                  🪷✨ เทศกาลลอยกระทง – ร่วมฉลองค่ำคืนแห่งความสุข ✨🪷

                  ร่วมสัมผัสบรรยากาศเทศกาลลอยกระทง
                  พร้อมกิจกรรมและโปรโมชั่นพิเศษสำหรับสมาชิก QK88BET

                  🎁 ติดตามกิจกรรม โบนัส และสิทธิประโยชน์
                  ที่จัดขึ้นเป็นพิเศษในช่วงเทศกาล

                  📌 กรุณาตรวจสอบรายละเอียดและเงื่อนไข
                  จากหน้าโปรโมชั่นก่อนเข้าร่วมกิจกรรม
                </p>

                <p className="app-marquee__item">
                  🔥 โปรโมชั่น ON CASINO – รับเงินคืนสูงสุด 20% 🔥

                  🎁 โปรโมชั่นพิเศษสำหรับสมาชิก:
                  เมื่อเข้าร่วมเดิมพัน BACCARAT ในห้อง ON CASINO
                  และตรงตามเงื่อนไขของกิจกรรม
                  สามารถรับเงินคืนสูงสุด 20% ตามข้อกำหนดของโปรโมชั่น

                  💰 โปรโมชั่นฝากเงิน – รับโบนัสสูงสุด 3%

                  ⮞ วิธีรับโบนัส:
                  เลือก VOUCHER ที่ต้องการก่อนทำรายการฝากเงิน

                  📌 กรุณาตรวจสอบรายละเอียด เงื่อนไข
                  และยอดเทิร์นของโปรโมชั่นก่อนเข้าร่วม
                </p>

                <p className="app-marquee__item">
                  🎰🐟 SLOT & เกมยิงปลา – รับโบนัสสูงสุด 10% 🎁

                  พบกับโปรโมชั่นพิเศษสำหรับสมาชิก
                  ที่ชื่นชอบ SLOT และเกมยิงปลา

                  🎁 รับสิทธิประโยชน์และโบนัส
                  ตามโปรโมชั่นที่ร่วมรายการ

                  ⮞ หมายเหตุ ⮜
                  กรุณาตรวจสอบรายละเอียดและเงื่อนไข
                  ของโปรโมชั่นก่อนเข้าร่วมทุกครั้ง

                  📌 รายละเอียดเพิ่มเติม:
                  ติดต่อฝ่ายบริการลูกค้าออนไลน์ QK88BET
                </p>

                <p className="app-marquee__item">
                  ⚠️ ข้อควรระวังในการฝากเงินกับ QK88BET ⚠️

                  ✅ ใช้ข้อมูลการฝากเงินล่าสุด
                  จากเมนู “ฝากเงิน” บนเว็บไซต์ QK88BET เท่านั้น

                  ✅ ตรวจสอบชื่อธนาคาร เลขบัญชี จำนวนเงิน
                  และรายละเอียดการโอนให้ถูกต้องก่อนยืนยันทุกครั้ง

                  ❌ ห้ามใช้เลขบัญชีธนาคารหรือที่อยู่กระเป๋า USDT
                  จากรายการเก่า เนื่องจากช่องทางการฝากอาจมีการเปลี่ยนแปลง

                  ❌ ห้ามโอนเงินตามข้อมูลที่ได้รับจากบุคคลภายนอก
                  หรือผู้ที่แอบอ้างเป็นเจ้าหน้าที่

                  ⭐️ กรุณากรอกข้อมูลการฝากเงิน
                  ให้ตรงกับรายการโอนจริง

                  ⭐️ แนะนำให้ใช้บัญชีธนาคาร
                  ที่ตรงกับชื่อที่ลงทะเบียนไว้กับสมาชิก

                  ⭐️ ตรวจสอบข้อมูลให้ถูกต้องทุกครั้งก่อนโอนเงิน

                  หากโอนเงินไปยังบัญชีหรือกระเป๋า USDT
                  ที่หมดอายุหรือไม่ได้ใช้งานแล้ว
                  กรุณาติดต่อฝ่ายบริการลูกค้าทันทีเพื่อตรวจสอบรายการ

                  ☎️ ฝ่ายบริการลูกค้าออนไลน์พร้อมให้บริการตลอด 24 ชั่วโมง
                </p>

                <p className="app-marquee__item">
                  ⚽️ สนุกกับฟุตบอลและกิจกรรมกีฬากับ QK88BET ⚽️

                  ติดตามการแข่งขันกีฬาคู่สำคัญ
                  พร้อมร่วมกิจกรรมพิเศษสำหรับสมาชิกในช่วงการแข่งขัน

                  🎁 สมาชิกสามารถติดตามกิจกรรม
                  โบนัส และสิทธิประโยชน์เพิ่มเติม
                  ได้จากหน้าโปรโมชั่นและประกาศของ QK88BET

                  📌 สำหรับรายละเอียดเพิ่มเติม
                  กรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์
                </p>

                <p className="app-marquee__item">
                  💰 โปรแกรมแนะนำเพื่อน – รับสิทธิประโยชน์เพิ่มเติม 💰

                  แนะนำเพื่อนเข้าร่วม QK88BET
                  และรับสิทธิประโยชน์ตามเงื่อนไข
                  ของโปรแกรมแนะนำสมาชิก

                  🎁 สมาชิกใหม่ที่คุณแนะนำ
                  สามารถรับสิทธิประโยชน์ตามโปรโมชั่นที่กำหนด

                  💎 สิทธิประโยชน์และค่าคอมมิชชั่น
                  จะคำนวณตามเงื่อนไขของกิจกรรม

                  📌 รายละเอียดเพิ่มเติม:
                  ไปที่เมนู “ของฉัน” ➤ “แนะนำเพื่อน”
                  หรือติดต่อฝ่ายบริการลูกค้าออนไลน์
                </p>

                <p className="app-marquee__item">
                  ☎️ ฝ่ายบริการลูกค้าออนไลน์ 24 ชั่วโมง

                  เรียนสมาชิกทุกท่าน

                  หากมีคำถามหรือพบปัญหาระหว่างการใช้งาน
                  กรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์
                  ผ่านช่องทางอย่างเป็นทางการของ QK88BET

                  ทีมงานพร้อมให้บริการและช่วยเหลือตลอด 24 ชั่วโมง

                  🇹🇭 สุขสันต์วันสงกรานต์ 💦
                  🪷 สุขสันต์วันลอยกระทง
                  🎆 สวัสดีปีใหม่ 🎉

                  🍀 QK88BET ขอให้สมาชิกทุกท่านโชคดี!
                </p>

              </div>
            </div>

            {/* BLOCK 2 - Lặp lại để marquee chạy liên tục */}
            <div className="marquee-text-text">
              <div className="app-marquee__marquees">

                <p className="app-marquee__item">
                  ⭐️ เดิมพันเต็มที่ – รับเงินคืนทันทีสูงสุด 2.5% ⭐️

                  สนุกกับการเดิมพัน พร้อมรับสิทธิ์เงินคืนตามเงื่อนไขของโปรโมชั่น
                  โดยไม่ต้องรอถึงวันถัดไป!

                  ✤ วิธีรับเงินคืน:
                  ไปที่เมนู “ของฉัน” ➤ เลือก “รับเงินคืนทันที”
                  ➤ กด “คำนวณเงินคืน” ➤ รับเงินคืนตามยอดที่ระบบแสดง
                </p>

                <p className="app-marquee__item">
                  🇹🇭💦 ฉลองเทศกาลสงกรานต์กับ QK88BET 💦🇹🇭

                  🎉 สุขสันต์วันสงกรานต์ – เทศกาลปีใหม่ไทย
                  พบกับกิจกรรมพิเศษ โบนัส และสิทธิประโยชน์มากมายสำหรับสมาชิก

                  💦 ร่วมสนุกตลอดช่วงเทศกาลสงกรานต์
                  พร้อมติดตามกิจกรรมและโปรโมชั่นพิเศษจาก QK88BET

                  🎁 โปรโมชั่นและกิจกรรมอาจแตกต่างกันไปตามช่วงเวลา
                  กรุณาตรวจสอบรายละเอียดและเงื่อนไขจากหน้าโปรโมชั่นก่อนเข้าร่วม

                  🍀 ขอให้สมาชิกทุกท่านมีความสุข สนุก และโชคดีตลอดเทศกาลสงกรานต์!
                </p>

                <p className="app-marquee__item">
                  🎆🎁 ฉลองเทศกาลปีใหม่กับ QK88BET 🎁🎆

                  เริ่มต้นปีใหม่ด้วยความสนุก
                  พร้อมกิจกรรมและโปรโมชั่นพิเศษสำหรับสมาชิก

                  🎊 พบกับโบนัส กิจกรรม และสิทธิประโยชน์ต่าง ๆ
                  ที่จัดขึ้นในช่วงเทศกาลปีใหม่

                  📌 ติดตามรายละเอียดล่าสุดได้จากหน้าโปรโมชั่น
                  หรือสอบถามฝ่ายบริการลูกค้าออนไลน์

                  🎉 QK88BET ขอให้สมาชิกทุกท่านมีความสุขและโชคดีตลอดปี!
                </p>

                <p className="app-marquee__item">
                  🪷✨ เทศกาลลอยกระทง – ร่วมฉลองค่ำคืนแห่งความสุข ✨🪷

                  ร่วมสัมผัสบรรยากาศเทศกาลลอยกระทง
                  พร้อมกิจกรรมและโปรโมชั่นพิเศษสำหรับสมาชิก QK88BET

                  🎁 ติดตามกิจกรรม โบนัส และสิทธิประโยชน์
                  ที่จัดขึ้นเป็นพิเศษในช่วงเทศกาล

                  📌 กรุณาตรวจสอบรายละเอียดและเงื่อนไข
                  จากหน้าโปรโมชั่นก่อนเข้าร่วมกิจกรรม
                </p>

                <p className="app-marquee__item">
                  🔥 โปรโมชั่น ON CASINO – รับเงินคืนสูงสุด 20% 🔥

                  🎁 โปรโมชั่นพิเศษสำหรับสมาชิก:
                  เมื่อเข้าร่วมเดิมพัน BACCARAT ในห้อง ON CASINO
                  และตรงตามเงื่อนไขของกิจกรรม
                  สามารถรับเงินคืนสูงสุด 20% ตามข้อกำหนดของโปรโมชั่น

                  💰 โปรโมชั่นฝากเงิน – รับโบนัสสูงสุด 3%

                  ⮞ วิธีรับโบนัส:
                  เลือก VOUCHER ที่ต้องการก่อนทำรายการฝากเงิน

                  📌 กรุณาตรวจสอบรายละเอียด เงื่อนไข
                  และยอดเทิร์นของโปรโมชั่นก่อนเข้าร่วม
                </p>

                <p className="app-marquee__item">
                  🎰🐟 SLOT & เกมยิงปลา – รับโบนัสสูงสุด 10% 🎁

                  พบกับโปรโมชั่นพิเศษสำหรับสมาชิก
                  ที่ชื่นชอบ SLOT และเกมยิงปลา

                  🎁 รับสิทธิประโยชน์และโบนัส
                  ตามโปรโมชั่นที่ร่วมรายการ

                  ⮞ หมายเหตุ ⮜
                  กรุณาตรวจสอบรายละเอียดและเงื่อนไข
                  ของโปรโมชั่นก่อนเข้าร่วมทุกครั้ง

                  📌 รายละเอียดเพิ่มเติม:
                  ติดต่อฝ่ายบริการลูกค้าออนไลน์ QK88BET
                </p>

                <p className="app-marquee__item">
                  ⚠️ ข้อควรระวังในการฝากเงินกับ QK88BET ⚠️

                  ✅ ใช้ข้อมูลการฝากเงินล่าสุด
                  จากเมนู “ฝากเงิน” บนเว็บไซต์ QK88BET เท่านั้น

                  ✅ ตรวจสอบชื่อธนาคาร เลขบัญชี จำนวนเงิน
                  และรายละเอียดการโอนให้ถูกต้องก่อนยืนยันทุกครั้ง

                  ❌ ห้ามใช้เลขบัญชีธนาคารหรือที่อยู่กระเป๋า USDT
                  จากรายการเก่า เนื่องจากช่องทางการฝากอาจมีการเปลี่ยนแปลง

                  ❌ ห้ามโอนเงินตามข้อมูลที่ได้รับจากบุคคลภายนอก
                  หรือผู้ที่แอบอ้างเป็นเจ้าหน้าที่

                  ⭐️ กรุณากรอกข้อมูลการฝากเงิน
                  ให้ตรงกับรายการโอนจริง

                  ⭐️ แนะนำให้ใช้บัญชีธนาคาร
                  ที่ตรงกับชื่อที่ลงทะเบียนไว้กับสมาชิก

                  ⭐️ ตรวจสอบข้อมูลให้ถูกต้องทุกครั้งก่อนโอนเงิน

                  หากโอนเงินไปยังบัญชีหรือกระเป๋า USDT
                  ที่หมดอายุหรือไม่ได้ใช้งานแล้ว
                  กรุณาติดต่อฝ่ายบริการลูกค้าทันทีเพื่อตรวจสอบรายการ

                  ☎️ ฝ่ายบริการลูกค้าออนไลน์พร้อมให้บริการตลอด 24 ชั่วโมง
                </p>

                <p className="app-marquee__item">
                  ⚽️ สนุกกับฟุตบอลและกิจกรรมกีฬากับ QK88BET ⚽️

                  ติดตามการแข่งขันกีฬาคู่สำคัญ
                  พร้อมร่วมกิจกรรมพิเศษสำหรับสมาชิกในช่วงการแข่งขัน

                  🎁 สมาชิกสามารถติดตามกิจกรรม
                  โบนัส และสิทธิประโยชน์เพิ่มเติม
                  ได้จากหน้าโปรโมชั่นและประกาศของ QK88BET

                  📌 สำหรับรายละเอียดเพิ่มเติม
                  กรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์
                </p>

                <p className="app-marquee__item">
                  💰 โปรแกรมแนะนำเพื่อน – รับสิทธิประโยชน์เพิ่มเติม 💰

                  แนะนำเพื่อนเข้าร่วม QK88BET
                  และรับสิทธิประโยชน์ตามเงื่อนไข
                  ของโปรแกรมแนะนำสมาชิก

                  🎁 สมาชิกใหม่ที่คุณแนะนำ
                  สามารถรับสิทธิประโยชน์ตามโปรโมชั่นที่กำหนด

                  💎 สิทธิประโยชน์และค่าคอมมิชชั่น
                  จะคำนวณตามเงื่อนไขของกิจกรรม

                  📌 รายละเอียดเพิ่มเติม:
                  ไปที่เมนู “ของฉัน” ➤ “แนะนำเพื่อน”
                  หรือติดต่อฝ่ายบริการลูกค้าออนไลน์
                </p>

                <p className="app-marquee__item">
                  ☎️ ฝ่ายบริการลูกค้าออนไลน์ 24 ชั่วโมง

                  เรียนสมาชิกทุกท่าน

                  หากมีคำถามหรือพบปัญหาระหว่างการใช้งาน
                  กรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์
                  ผ่านช่องทางอย่างเป็นทางการของ QK88BET

                  ทีมงานพร้อมให้บริการและช่วยเหลือตลอด 24 ชั่วโมง

                  🇹🇭 สุขสันต์วันสงกรานต์ 💦
                  🪷 สุขสันต์วันลอยกระทง
                  🎆 สวัสดีปีใหม่ 🎉

                  🍀 QK88BET ขอให้สมาชิกทุกท่านโชคดี!
                </p>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default ChuChayMobile;